import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash;
    const sid = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sid });
        window.location.href = "/dashboard";
      } catch {
        window.location.href = "/login?error=google";
      }
    })();
  }, []);
  return <div className="min-h-screen grid place-items-center bg-base text-neon font-mono">authenticating…</div>;
}
